import callAPiBase from './base';

const notificationApi = {
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/notification',
      method: 'POST',
      useToken: true,
      data,
    }),
};

export { notificationApi };
export default notificationApi;
